import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { DropdownOption } from '@products/types';
import {
  DropdownComponent,
  HighchartsThemeService,
  ResponsiveService,
} from '@frk/eds-components';
import { CalculatorUtility, EnvelopeTableData } from './calculator.utility';
import { Observable } from 'rxjs';
import Highcharts from 'highcharts';

@Component({
  selector: 'ft-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
})
export class CalculatorComponent
  extends AbstractBaseComponent
  implements OnInit, AfterViewInit {
  calculatorType: string;

  translationLabel: any;

  footNote: string;
  fedTaxLabel: string;
  stateSelectionLabel: string;
  hypoYieldLabel: string;
  taxYieldCalculatorTableHeading: string;
  taxYieldCalculatorResultHeading: string;
  taxYieldTableIncome: string;
  taxYieldTableJointReturn: string;
  taxYieldCalculatorJoint24: number;
  taxYieldCalculatorReturn24: number;
  taxYieldCalculatorJoint32: number;
  taxYieldCalculatorReturn32: number;
  taxYieldCalculatorJoint35: number;
  taxYieldCalculatorReturn35: number;
  taxYieldCalculatorJoint37: number;
  taxYieldCalculatorResultAPart1: string;
  taxYieldCalculatorResultAPart2: string;
  taxYieldCalculatorCalculateLabel: string;

  fedTaxInvalid: boolean;
  stateInvalid: boolean;
  hypoInvalid: boolean;

  dropdownTaxRateRange: DropdownOption[] = [];
  dropdownStateRange: DropdownOption[] = [];
  dropdownHypoRange: DropdownOption[] = [];

  calculated: boolean;
  missingFields: boolean;

  selectedHypotheticalYield: number;
  selectedFedTax: number;
  selectedState: string;

  finalValue: number;
  displayHypotheticalYield: number;

  placeHolderText: string;

  rothIraCalculated: boolean;

  rothIraRetirementRates: DropdownOption[];
  rothIraDuringRetirementRates: DropdownOption[];
  rothIraSaveUntilRetirement: DropdownOption[];
  rothIraSaveAfterRetirement: DropdownOption[];
  rothIraFedTaxRate: DropdownOption[];
  rothIraFedTaxRateDuringRetirement: DropdownOption[];

  step1Input: string;
  step2Input: string;
  step3Input: string;
  step4Input: string;
  step5Input: string;
  step6Input: string;
  step7Input: string;
  step8Input: string;

  taxYieldCalculatorStateSelectionInvalid: string;
  taxYieldCalculatorHypoYieldInvalid: string;
  taxYieldCalculatorFedTaxInvalid: string;

  @ViewChildren('step3DropDown') step3DropDown: QueryList<DropdownComponent>;
  @ViewChildren('step4DropDown') step4DropDown: QueryList<DropdownComponent>;
  @ViewChildren('step5DropDown') step5DropDown: QueryList<DropdownComponent>;
  @ViewChildren('step6DropDown') step6DropDown: QueryList<DropdownComponent>;
  @ViewChildren('step7DropDown') step7DropDown: QueryList<DropdownComponent>;
  @ViewChildren('step8DropDown') step8DropDown: QueryList<DropdownComponent>;

  @ViewChild('rothIraResult') rothIraResultRef: ElementRef;

  rothIra: number;
  traditionalIra: number;
  rothIraMissingFields: boolean;

  rothIraStep1Label: string;
  rothIraStep2Label: string;
  rothIraStep3Label: string;
  rothIraStep4Label: string;
  rothIraStep5Label: string;
  rothIraStep6Label: string;
  rothIraStep7Label: string;
  rothIraStep8Label: string;

  step1Invalid: boolean;
  step2Invalid: boolean;
  step3Invalid: boolean;
  step4Invalid: boolean;
  step5Invalid: boolean;
  step6Invalid: boolean;
  step7Invalid: boolean;
  step8Invalid: boolean;

  rothIraMissing: string;
  rothIraStep1Missing: string;
  rothIraStep2Missing: string;
  rothIraStep3Missing: string;
  rothIraStep4Missing: string;
  rothIraStep5Missing: string;
  rothIraStep6Missing: string;
  rothIraStep7Missing: string;
  rothIraStep8Missing: string;

  rothIraCalulatedHeading: string;
  rothIraConvertToRoth: string;
  rothIraDontConvertToRoth: string;
  rothIraStep2HelperText: string;
  rothIraStep3HelperText: string;
  rothIraStep4HelperText: string;
  rothIraResultHeading: string;
  rothIraResultListItem1: string;
  rothIraResultListItem2: string;
  rothIraResultListItem3: string;
  rothIraResultListItem4: string;
  rothIraCalculateLabel: string;
  rothIraClearLabel: string;
  rothIraYearsLabel: string;
  rothIraPercentageValue: string;

  monthlyContributionYearsLeft: string;
  monthlyContributionMonthlyContribution: string;
  monthlyContributionRateOfReturn: string;
  monthlyContributionResult1: string;
  monthlyContributionResult2: string;
  monthlyContributionResult3: string;
  monthlyContributionResult4: string;
  monthlyContributionContributeMore: string;
  monthlyContributionChartHeading: string;
  monthlyContributionHypoSavings1: string;
  monthlyContributionHypoSavings2: string;
  monthlyContributionCalculateLabel: string;
  monthlyContriYears: number;
  monthlyContriAmount: number;
  monthlyContriRate: number;
  monthlyContriFutureValue: number;

  updateChart: boolean;

  highcharts;
  chartOptions: Highcharts.Options;
  monthlyContriCurrentStep: number;
  monthlyContriStepInfo: string[];

  months: string[];
  colsData: EnvelopeTableData[];
  revealShowAllText: string;
  isHandheld$: Observable<boolean>;

  envelopeTableRevealAll: string;
  envelopeTableHideAll: string;

  constructor(
    protected responsiveService: ResponsiveService,
    private changeDetectorRef: ChangeDetectorRef,
    private highchartsTheme: HighchartsThemeService
  ) {
    super();
  }

  ngAfterViewInit() {
    // Init chart on AfterViewInit so that it calculates container width correctly
    this.chartOptions = {
      chart: {
        type: 'area',
        plotBorderWidth: 1,
      },
      title: {
        text: '',
      },
      xAxis: {
        gridZIndex: 4,
        gridLineWidth: 1,
        tickWidth: 0,
        tickInterval: 1,
        alignTicks: true,
        minPadding: 0,
        maxPadding: 0,
        title: {
          text: this.translationLabel?.monthlyContriChartXAxis,
        },
      },
      yAxis: [
        {
          gridLineWidth: 0,
          opposite: true,
          title: {
            text: '',
          },
          showFirstLabel: false,
          showLastLabel: false,
          tickPositioner() {
            const prevTickPos = this.tickPositions;
            const newTickPositions = [
              prevTickPos[0],
              prevTickPos[prevTickPos.length - 1],
            ];
            const series = this.chart.series;
            series.forEach((s: any) => {
              newTickPositions.push(
                s.processedYData[s.processedYData.length - 1]
              );
            });
            newTickPositions.sort((a, b) => {
              return a - b;
            });
            return newTickPositions;
          },
          labels: {
            enabled: true,
            align: 'right',
            reserveSpace: true,
            formatter() {
              const strValue = this.value + '';
              return (
                // add Commas at thousand's place
                '$' + strValue.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
              );
            },
          },
        },
        {
          title: {
            text: this.translationLabel?.monthlyContriChartYAxis,
          },
        },
      ],
      plotOptions: {
        area: {
          lineWidth: 1,
          fillOpacity: 1,
          dataLabels: {
            crop: !1,
            align: 'right',
            y: 5,
          },
          marker: {
            enabled: !1,
          },
        },
      },
      series: [
        {
          showInLegend: false,
          enableMouseTracking: false,
          data: [],
          type: 'area',
        },
        {
          showInLegend: false,
          enableMouseTracking: false,
          data: [],
          type: 'area',
        },
        {
          showInLegend: false,
          enableMouseTracking: false,
          data: [],
          type: 'area',
        },
      ],
    };
  }
  ngOnInit(): void {
    import(/* webpackChunkName: "highcharts-async" */ 'highcharts').then(
      (highchartsModule) => {
        highchartsModule.setOptions(this.highchartsTheme.themeOptions);
        this.highcharts = highchartsModule;
      }
    );

    this.isHandheld$ = this.responsiveService.isHandheld$();

    this.monthlyContriYears = 1;
    this.monthlyContriAmount = 25;
    this.monthlyContriRate = 2;

    // Get calculatorType models from Bloomreach

    this.translationLabel = this.component?.getModels()['ft.core.calculator'];

    this.revealShowAllText = this.translationLabel?.envelopeTableRevealAll;
    this.months = CalculatorUtility.getEnvelopeTableMonths(
      this.translationLabel
    );

    this.colsData = CalculatorUtility.getEnvelopeTableData(
      this.translationLabel
    );

    this.placeHolderText = this.translationLabel?.taxYieldCalculatorPlaceHolderText;
    this.footNote = this.translationLabel?.taxYieldCalculatorFootNote;
    this.fedTaxLabel = this.translationLabel?.taxYieldCalculatorFedTaxLabel;
    this.stateSelectionLabel = this.translationLabel?.taxYieldCalculatorStateSelectionLabel;
    this.hypoYieldLabel = this.translationLabel?.taxYieldCalculatorHypoYieldLabel;
    this.taxYieldCalculatorTableHeading = this.translationLabel?.taxYieldCalculatorTableHeading;

    this.taxYieldCalculatorStateSelectionInvalid = this.translationLabel?.taxYieldCalculatorStateSelectionInvalid;
    this.taxYieldCalculatorHypoYieldInvalid = this.translationLabel?.taxYieldCalculatorHypoYieldInvalid;
    this.taxYieldCalculatorFedTaxInvalid = this.translationLabel?.taxYieldCalculatorFedTaxInvalid;

    this.taxYieldCalculatorResultHeading = this.translationLabel?.taxYieldCalculatorResultHeading;

    this.taxYieldTableIncome = this.translationLabel?.taxYieldTableIncome;

    this.taxYieldTableJointReturn = this.translationLabel?.taxYieldTableJointReturn;
    this.taxYieldCalculatorJoint24 = this.translationLabel?.taxYieldCalculatorJoint24;
    this.taxYieldCalculatorReturn24 = this.translationLabel?.taxYieldCalculatorReturn24;
    this.taxYieldCalculatorJoint32 = this.translationLabel?.taxYieldCalculatorJoint32;
    this.taxYieldCalculatorReturn32 = this.translationLabel?.taxYieldCalculatorReturn32;
    this.taxYieldCalculatorJoint35 = this.translationLabel?.taxYieldCalculatorJoint35;
    this.taxYieldCalculatorReturn35 = this.translationLabel?.taxYieldCalculatorReturn35;
    this.taxYieldCalculatorJoint37 = this.translationLabel?.taxYieldCalculatorJoint37;
    this.taxYieldCalculatorResultAPart1 = this.translationLabel?.taxYieldCalculatorResultAPart1;
    this.taxYieldCalculatorResultAPart2 = this.translationLabel?.taxYieldCalculatorResultAPart2;
    this.taxYieldCalculatorCalculateLabel = this.translationLabel?.taxYieldCalculatorCalculateLabel;

    // Roth IRA Calculator Labels

    this.rothIraCalulatedHeading = this.translationLabel?.rothIraCalulatedHeading;
    this.rothIraConvertToRoth = this.translationLabel?.rothIraConvertToRoth;
    this.rothIraDontConvertToRoth = this.translationLabel?.rothIraDontConvertToRoth;
    this.rothIraStep2HelperText = this.translationLabel?.rothIraStep2HelperText;
    this.rothIraStep3HelperText = this.translationLabel?.rothIraStep3HelperText;
    this.rothIraStep4HelperText = this.translationLabel?.rothIraStep4HelperText;
    this.rothIraCalculateLabel = this.translationLabel?.rothIraCalculateLabel;

    this.rothIraResultHeading = this.translationLabel?.rothIraResultHeading;
    this.rothIraResultListItem1 = this.translationLabel?.rothIraResultListItem1;
    this.rothIraResultListItem2 = this.translationLabel?.rothIraResultListItem2;
    this.rothIraResultListItem3 = this.translationLabel?.rothIraResultListItem3;
    this.rothIraResultListItem4 = this.translationLabel?.rothIraResultListItem4;
    this.rothIraClearLabel = this.translationLabel?.rothIraClearLabel;
    this.rothIraYearsLabel = this.translationLabel?.rothIraYearsLabel;
    this.rothIraPercentageValue = this.translationLabel?.rothIraPercentageValue;

    this.rothIraStep1Label = this.translationLabel?.rothIraStep1Label;
    this.rothIraStep2Label = this.translationLabel?.rothIraStep2Label;
    this.rothIraStep3Label = this.translationLabel?.rothIraStep3Label;
    this.rothIraStep4Label = this.translationLabel?.rothIraStep4Label;
    this.rothIraStep5Label = this.translationLabel?.rothIraStep5Label;
    this.rothIraStep6Label = this.translationLabel?.rothIraStep6Label;
    this.rothIraStep7Label = this.translationLabel?.rothIraStep7Label;
    this.rothIraStep8Label = this.translationLabel?.rothIraStep8Label;

    this.rothIraMissing = this.translationLabel?.rothIraMissing;
    this.rothIraStep1Missing = this.translationLabel?.rothIraStep1Missing;
    this.rothIraStep2Missing = this.translationLabel?.rothIraStep2Missing;
    this.rothIraStep3Missing = this.translationLabel?.rothIraStep3Missing;
    this.rothIraStep4Missing = this.translationLabel?.rothIraStep4Missing;
    this.rothIraStep5Missing = this.translationLabel?.rothIraStep5Missing;
    this.rothIraStep6Missing = this.translationLabel?.rothIraStep6Missing;
    this.rothIraStep7Missing = this.translationLabel?.rothIraStep7Missing;
    this.rothIraStep8Missing = this.translationLabel?.rothIraStep8Missing;

    // Monthly Contribution Calculator labels
    this.monthlyContributionYearsLeft = this.translationLabel?.monthlyContributionYearsLeft;
    this.monthlyContributionMonthlyContribution = this.translationLabel?.monthlyContributionMonthlyContribution;

    this.monthlyContributionRateOfReturn = this.translationLabel?.monthlyContributionRateOfReturn;
    this.monthlyContributionCalculateLabel = this.translationLabel?.monthlyContributionCalculateLabel;
    this.monthlyContributionResult1 = this.translationLabel?.monthlyContributionResult1;
    this.monthlyContributionResult2 = this.translationLabel?.monthlyContributionResult2;
    this.monthlyContributionResult3 = this.translationLabel?.monthlyContributionResult3;
    this.monthlyContributionResult4 = this.translationLabel?.monthlyContributionResult4;
    this.monthlyContributionContributeMore = this.translationLabel?.monthlyContributionContributeMore;
    this.monthlyContributionChartHeading = this.translationLabel?.monthlyContributionChartHeading;
    this.monthlyContributionHypoSavings1 = this.translationLabel?.monthlyContributionHypoSavings1;
    this.monthlyContributionHypoSavings2 = this.translationLabel?.monthlyContributionHypoSavings2;
    this.monthlyContributionCalculateLabel = this.translationLabel?.monthlyContributionCalculateLabel;

    // Get calculatorType Parameter from Bloomreach

    this.calculatorType = this.component?.getParameters().calculatorType;

    this.dropdownTaxRateRange = CalculatorUtility.getTaxRateRange();

    this.dropdownHypoRange = CalculatorUtility.getHypoRange();
    this.dropdownStateRange = CalculatorUtility.getStateRange();

    this.rothIraRetirementRates = CalculatorUtility.getBeforeRetirementRates();
    this.rothIraDuringRetirementRates = CalculatorUtility.getBeforeRetirementRates();
    this.rothIraSaveUntilRetirement = CalculatorUtility.getRetirementYears();
    this.rothIraSaveAfterRetirement = CalculatorUtility.getRetirementYears();
    this.rothIraFedTaxRate = CalculatorUtility.getIraFedTaxRates();
    this.rothIraFedTaxRateDuringRetirement = CalculatorUtility.getIraFedTaxRates();

    this.monthlyContriStepInfo = ['2%', '4%', '6%', '8%'];
    this.monthlyContriCurrentStep = 0;
    this.monthlyContriRate = +this.monthlyContriStepInfo[
      this.monthlyContriCurrentStep
    ].replace(/%/g, '');
  }
  toggleRevealAll() {
    if (
      this.revealShowAllText === this.translationLabel?.envelopeTableRevealAll
    ) {
      this.revealShowAllText = this.translationLabel?.envelopeTableHideAll;
      CalculatorUtility.setEnvelopeTableShowImage(this.colsData, false);
    } else {
      this.revealShowAllText = this.translationLabel?.envelopeTableRevealAll;
      CalculatorUtility.setEnvelopeTableShowImage(this.colsData, true);
    }
  }
  onFedTaxChange(taxEvent) {
    this.fedTaxInvalid = false;
    this.selectedFedTax = +taxEvent.value;
  }

  onHypoChange(hypoTaxEvent) {
    this.hypoInvalid = false;
    this.selectedHypotheticalYield = +hypoTaxEvent.value;
  }

  onStateChange(stateEvent) {
    this.stateInvalid = false;
    this.selectedState = stateEvent.value;
  }

  setIraStep1(val) {
    this.step1Input = val;
    if (this.step1Input) {
      this.step1Invalid = false;
    }
  }

  setIraStep2(val) {
    this.step2Input = val;
    if (this.step2Input) {
      this.step2Invalid = false;
    }
  }

  setIraStep3(event) {
    this.step3Input = event.value;
    this.step3Invalid = false;
  }

  setIraStep4(event) {
    this.step4Invalid = false;
    this.step4Input = event.value;
  }

  setIraStep5(event) {
    this.step5Invalid = false;
    this.step5Input = event.value;
  }

  setIraStep6(event) {
    this.step6Invalid = false;
    this.step6Input = event.value;
  }

  setIraStep7(event) {
    this.step7Invalid = false;
    this.step7Input = event.value;
  }

  setIraStep8(event) {
    this.step8Invalid = false;
    this.step8Input = event.value;
  }

  reset() {
    this.rothIraCalculated = false;
    this.rothIraMissingFields = false;

    this.step1Input = '';
    this.step2Input = '';
    this.step3Input = '';
    this.step4Input = '';
    this.step5Input = '';
    this.step6Input = '';
    this.step7Input = '';
    this.step8Input = '';

    this.step3DropDown.forEach((dropDown) => {
      dropDown.reset();
    });
    this.step4DropDown.forEach((dropDown) => {
      dropDown.reset();
    });
    this.step5DropDown.forEach((dropDown) => {
      dropDown.reset();
    });
    this.step6DropDown.forEach((dropDown) => {
      dropDown.reset();
    });
    this.step7DropDown.forEach((dropDown) => {
      dropDown.reset();
    });
    this.step8DropDown.forEach((dropDown) => {
      dropDown.reset();
    });
  }

  calculate() {
    if (
      !(
        this.selectedFedTax &&
        this.selectedHypotheticalYield &&
        this.selectedState
      )
    ) {
      // Show missing fields error message
      this.missingFields = true;
      if (!this.selectedFedTax) {
        this.fedTaxInvalid = true;
      }
      if (!this.selectedState) {
        this.stateInvalid = true;
      }
      if (!this.selectedHypotheticalYield) {
        this.hypoInvalid = true;
      }
    } else {
      // State Income and Tax Rates = [state taxes based on tax bracket],
      // [combined rates (city/county + state rate + federal rate + federal medicare)]

      const stateTaxRange = CalculatorUtility.getTaxTable();
      const fedTaxRange = ['24.00', '32.00', '35.00', '37.00'];

      const fed = this.selectedFedTax;
      const fedTax = parseFloat(fedTaxRange[fed - 1]) / 100;
      const state = this.selectedState;
      const stateTax = parseFloat(stateTaxRange[state][0][fed - 1]) / 100;
      const cityTax = parseFloat(stateTaxRange[state][1][fed - 1]) / 100;

      const taxYield = +this.selectedHypotheticalYield;

      const combinedTax = cityTax;

      // Round to last two decimals
      this.finalValue =
        Math.round(
          (((taxYield / (1 - combinedTax)) * 100) / 100 + Number.EPSILON) * 100
        ) / 100;

      this.calculated = true;
      this.missingFields = false;
      this.displayHypotheticalYield = this.selectedHypotheticalYield;
    }
  }

  calculateRothIRA() {
    if (
      !(
        this.step1Input &&
        this.step2Input &&
        this.step3Input &&
        this.step4Input &&
        this.step5Input &&
        this.step6Input &&
        this.step7Input &&
        this.step8Input
      )
    ) {
      // Show missing fields error message

      if (!this.step1Input) {
        this.step1Invalid = true;
      }

      if (!this.step2Input) {
        this.step2Invalid = true;
      }

      if (!this.step3Input) {
        this.step3Invalid = true;
      }
      if (!this.step4Input) {
        this.step4Invalid = true;
      }
      if (!this.step5Input) {
        this.step5Invalid = true;
      }

      if (!this.step6Input) {
        this.step6Invalid = true;
      }

      if (!this.step7Input) {
        this.step7Invalid = true;
      }

      if (!this.step8Input) {
        this.step8Invalid = true;
      }

      this.rothIraCalculated = false;
    } else {
      const step1 = +this.step1Input;
      const step2 = +this.step2Input;
      const step3 = +this.step3Input / 100;
      const step4 = +this.step4Input / 100;
      const step5 = +this.step5Input;
      const step6 = +this.step6Input;
      const step7 = +this.step7Input / 100;
      const step8 = +this.step8Input / 100;

      const step9 = (1 - step7) * step3;
      const step10 = (1 - step8) * step4;
      const step11 = CalculatorUtility.getFutureValueFactorsStep11(
        step3,
        step5
      );
      const step12 = CalculatorUtility.getFutureValueFactorsStep12(
        step5,
        step9
      );
      const step13 = CalculatorUtility.getIncomeFactorsStep13(step4, step6);
      const step14 = CalculatorUtility.getIncomeFactorsStep14(step6, step10);

      const step15 = step1 * step11;
      const step16 = (step15 / step13) * step6;
      const step17 = step1 - step2;
      const step18 = step17 * step7;
      const step19 = step18 * step12;
      const step20 = (step19 / step14) * step6;
      const step21 = step16 - step20;
      const step22 = step1 * step11;
      const step23 = step22 / step13;
      const step24 = step2 / step6;
      const step25 = step23 - step24;
      const step26 = (1 - step8) * step25;
      const step27 = (step24 + step26) * step6;

      this.rothIra = Math.round((step21 + Number.EPSILON) * 100) / 100;
      this.traditionalIra = Math.round((step27 + Number.EPSILON) * 100) / 100;
      this.rothIraCalculated = true;
      this.changeDetectorRef.detectChanges();
      this.rothIraResultRef.nativeElement.scrollIntoView();
    }
  }

  calculateMonthlyContri() {
    this.monthlyContriFutureValue = CalculatorUtility.getFutureValueAnnuity(
      this.monthlyContriRate,
      this.monthlyContriAmount,
      this.monthlyContriYears
    );

    this.chartOptions.series = [
      {
        showInLegend: false,
        data: [
          [0, 0],
          [
            this.monthlyContriYears,
            CalculatorUtility.getFutureValueAnnuity(
              this.monthlyContriRate,
              this.monthlyContriAmount + 100,
              this.monthlyContriYears
            ),
          ],
        ],
        type: 'area',
      },
      {
        showInLegend: false,
        data: [
          [0, 0],
          [
            this.monthlyContriYears,
            CalculatorUtility.getFutureValueAnnuity(
              this.monthlyContriRate,
              this.monthlyContriAmount + 50,
              this.monthlyContriYears
            ),
          ],
        ],
        type: 'area',
      },
      {
        showInLegend: false,
        data: [
          [0, 0],
          [
            this.monthlyContriYears,
            CalculatorUtility.getFutureValueAnnuity(
              this.monthlyContriRate,
              this.monthlyContriAmount,
              this.monthlyContriYears
            ),
          ],
        ],
        type: 'area',
      },
    ];

    this.updateChart = true;
  }

  onYearValueChanged(event) {
    this.monthlyContriYears = event;
  }

  onRateValueChanged(event) {
    this.monthlyContriCurrentStep = event;
    this.monthlyContriRate = +this.monthlyContriStepInfo[
      this.monthlyContriCurrentStep
    ].replace(/%/g, '');
  }

  onAmountValueChanged(event) {
    this.monthlyContriAmount = event;
  }
}
